import React from "react";
import {colors} from "shared/colors";
import {ScaleLoader} from "react-spinners";
import PropTypes from 'prop-types';
import {TableCell, TableRow} from "@material-ui/core";

const TableLoader = (props) => {
    return (
        <TableRow>
            <TableCell colSpan={props.colSpan} align="center" className="py-16">
                <ScaleLoader color={colors.primary.main} loading={props.loading} size={150}/>
            </TableCell>
        </TableRow>
    );
};
TableLoader.propTypes = {
    colSpan: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired
};

export default TableLoader;
